"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var ArrowForward_1 = __importDefault(require("@mui/icons-material/ArrowForward"));
var material_1 = require("@mui/material");
var react_1 = __importStar(require("react"));
var html_react_parser_1 = __importDefault(require("html-react-parser"));
var Close_1 = __importDefault(require("@mui/icons-material/Close"));
var trans_1 = __importDefault(require("@/plugins/trans"));
var icons_1 = require("../../icons");
var ApplyDialogStyles_1 = require("./ApplyDialogStyles");
var ContentContext_1 = __importDefault(require("../../context/ContentContext"));
var Transition = (0, react_1.forwardRef)(function Transition(props, ref) {
    return (0, jsx_runtime_1.jsx)(material_1.Slide, __assign({ direction: "left", ref: ref }, props));
});
var ConfirmAccountBlockMobile = function () {
    var _a = (0, react_1.useState)(false), open = _a[0], setOpen = _a[1];
    var applyDialog = (0, react_1.useContext)(ContentContext_1.default).applyDialog;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: ApplyDialogStyles_1.confirmBlockStyles.mobileBlock, onClick: function () { return setOpen(true); } }, { children: [(0, jsx_runtime_1.jsx)(icons_1.RFIcon, { sx: { width: '2em', height: '2em' } }), trans_1.default.get('labels.frontend.auth.why_confirm_account'), (0, jsx_runtime_1.jsx)(ArrowForward_1.default, { sx: { width: '1.5em', height: '1.5em' } })] })), (0, jsx_runtime_1.jsxs)(material_1.Dialog, __assign({ fullScreen: true, fullWidth: true, open: open, sx: { '&.MuiDialog-root': { zIndex: 1500 } }, PaperProps: { sx: { backgroundColor: '#F4F2F4' } }, TransitionComponent: Transition }, { children: [(0, jsx_runtime_1.jsxs)(material_1.DialogTitle, __assign({ sx: ApplyDialogStyles_1.confirmBlockStyles.mobileBlock }, { children: [(0, jsx_runtime_1.jsx)(icons_1.RFIcon, { sx: { width: '2em', height: '2em' } }), trans_1.default.get('labels.frontend.auth.why_confirm_account'), (0, jsx_runtime_1.jsx)(material_1.IconButton, __assign({ sx: { color: 'white' }, onClick: function () { return setOpen(false); } }, { children: (0, jsx_runtime_1.jsx)(Close_1.default, {}) }))] })), (0, jsx_runtime_1.jsx)(material_1.DialogContent, { children: (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ sx: ApplyDialogStyles_1.confirmBlockStyles.textBlock }, { children: (0, html_react_parser_1.default)(applyDialog.registerBlock) })) })] }))] }));
};
exports.default = ConfirmAccountBlockMobile;
